// key names for local storage
export const lsToken = 'access-token';
export const lsAuthenticatedUser = 'authenticated-user';
export const lsUserType = 'user-type';

/**
 * Obtain token in the case user is authenticated
 * from the local storage
 * @returns {String} token
 */
export function getToken() {
  return localStorage.getItem(lsToken) || '';
}

/**
 * Auth Vuex Store Module State
 * @property {Boolean} smsVerified - If user passed the 2FA step
 * @property {string} token - Authentication token from API
 * @property {object} user - Authenticated user data from API
 * @property {object} modals - Data to trigger modal open
 * @property {string} guestToken - Stores user guest token
 * @property {string} phone - Stores phone provided by the user
 */
export const state = {
  token:              getToken(),
  user:               JSON.parse(localStorage.getItem(lsAuthenticatedUser)) || null,
  userType:           localStorage.getItem(lsUserType) || 'guest',
  pending:            false,
  beforeLoginMessage: null,
  modals:             {
    signIn:          false,
    claimAccount:    false,
    login:           false,
    forgotPassword:  false,
    resetPassword:   false,
    passwordChanged: false,
    linkSent:        false,
    accountCreated:  false,
  },
  guestToken:       '',
  customerToken:    '',
  phone:            '',
  email:            '',
  guestAccountData: {
    email:     '',
    firstName: '',
    lastName:  '',
    phone:     '',
  },
  notAuthUserData: {
    recipient_name: 'Not auth',
    first_name:     'Not auth',
    last_name:      'Not auth',
    phone:          'Not auth',
    email:          'Not auth',
  },
};

/**
 * Auth Vuex Store Module Getters
 * @property {boolean} isAuthentication - Checks if the user has been authenticated
 * @property {string} authToken - API Auth Token
 * @property {object} authUser - Authenticated user details
 */
export const getters = {
  isAuthenticated:       state => !!state.token && state.user,
  authToken:             state => state.token,
  authUser:              state => state.user,
  getNotAuthUserData:    state => state.notAuthUserData,
  authModalSignIn:       state => state.modals.signIn,
  authForgotPassword:    state => state.modals.forgotPassword,
  authResetPassword:     state => state.modals.resetPassword,
  authModalClaimAccount: state => state.modals.claimAccount,
  authModalLogin:        state => state.modals.login,
  authModal:             state => modalName => state.modals[modalName],
  userType:              state => state.userType,
  isGuest:               state => state.userType === 'guest',
  pending:               state => state.pending,
  guestAccountData:      state => state.guestAccountData,
  authPhone:             (state) => {
    const { user, phone: authPhone } = state;
    const userPhone = user ? user.phone : null;

    return authPhone || userPhone || '';
  },
  beforeLoginMessage: state => state.beforeLoginMessage,
};

export default {
  lsToken,
  lsAuthenticatedUser,
  getToken,
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/apps/auth/store/state.js